import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "staff-members",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "staff-members" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
});
